import React, { useState, useEffect, useRef } from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ListItemText from "@mui/material/ListItemText";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import { Mandatory } from "../../FormHelpers";
import OutlinedInput from "@mui/material/OutlinedInput";
import ClearIcon from "@mui/icons-material/Clear";
import { ChipChild, ChipDiv, FormContainer, PositionCloseIcon, StyledCheckBoxItem, StyledMenuItem } from "./Styled";
import CachedImage from "../../../../common/CachedImage";
import { ImagePath } from "../../../../../assets/ImagePath";



const ObjectInput2 = (props) => {
	const {
		id,
		info,
		readOnly,
		value,
		handleChange,
		onBlurField,
		validation,
		validationResult,
		validationMessage,
		options,
		isSections,
		multiple,
		isSmallScreen,
		title,
		type,
	} = props;

	const [selectOption, setSelectOption] = useState([]);
	const [val, setVal] = useState(value);
	const [multiSelectWidth, setMultiSelectWidth] = useState(300);
	const multiSelectRef = useRef(null);
	const [multiVal, setMultiVal] = useState((Array.isArray(value) && value) || []);
	const [shouldShowClrIcon, setShouldShowClrIcon] = useState(false);

	const handleSelect = (e) => {
		setVal((oldVal) => {
			return value;
		});
		setMultiVal(e.target.value);
		handleChange(e, type);
		onBlurField(e);
	};

	const onClear = (e) => {
		setVal((oldVal) => {
			return "";
		});
		const fakeEvt = { target: { name: id, value: "" } };
		handleChange(fakeEvt);
	};

	const onClearMultiple = (e) => {
		setMultiVal((oldMultiVal) => {
			return [];
		});
		const fakeEvt = { target: { name: id, value: [] } };
		handleChange(fakeEvt);
	};

	const handleMouseEnter = (e) => {
		setShouldShowClrIcon(true);
	};

	const handleMouseLeave = (e) => {
		setShouldShowClrIcon(false);
	};

	const handleItemDelete = (e, value) => {
		e.preventDefault();
		let valAfterDeletion = multiVal.filter((val) => val !== value);
		setMultiVal(valAfterDeletion);
		const fakeEvt = { target: { name: id, value: valAfterDeletion } };
		handleChange(fakeEvt, type);
		onBlurField(fakeEvt);
	};

	useEffect(() => {
		const multiWidth = multiSelectRef?.current?.offsetWidth;
		multiWidth && setMultiSelectWidth(multiWidth - 60);
	}, []);

	useEffect(() => {
		if (!options?.length && value) {
			setSelectOption([value]);
		} else if (options) {
			if (
				readOnly &&
				!options?.map((itemObj) => itemObj.value).includes(value)
			) {
				setSelectOption([...options, value]);
			} else {
				setSelectOption(options);
			}
		}
	}, [options, value, readOnly]);

	useEffect(() => {
		setVal((oldVal) => {
			return value;
		});
	}, [value]);

	useEffect(() => {
		setMultiVal((oldMultiVal) => {
			return value;
		});
	}, [value]);

	const isBoolean = (val) => "boolean" === typeof val;

	if (multiple) {
		<div className="relative flex items-start gap-1 update-input">
			<span className="min-w-[50px] h-[50px] rounded-7 flex items-center justify-center">
				<CachedImage
					image={ImagePath.dropdownIcon}
					imgKey="drop-picker-Icon"
					className="w-[50px] h-[50px]"
				/>
			</span>
			<div className="w-full">
				
					{(isSmallScreen || isSections === true) &&
						<label className="text-size-16 text-[#7C8DB5] font-regular">
							<Mandatory {...props} />{title}
						</label>
					}
				
				<FormContainer
					fullWidth
					multiSelWidth={multiSelectWidth}
					variant="outlined"
					disabled={readOnly}
					size="small"
					error={
						validation && isBoolean(validationResult) ? !validationResult : false
					}
					isValue={Boolean(value?.length)}
				>
					{/* {(isSmallScreen || isSections === true) && (
						<InputLabel id={id}>
							<Mandatory {...props} />
							{title}
						</InputLabel>
					)} */}
					<Select
						ref={multiSelectRef}
						labelId={id}
						multiple
						id={id}
						name={id}
						// label={id}
						input={<OutlinedInput label={title} />}
						value={multiVal || []}
						MenuProps={{
							anchorOrigin: {
								vertical: "bottom",
								horizontal: "center",
							},
							style: {
								maxHeight: 45 * 4.5,
							},
						}}
						onChange={handleSelect}
						onMouseEnter={handleMouseEnter}
						onMouseLeave={handleMouseLeave}
						renderValue={(selected) => {
							return (
								<ChipDiv>
									{selected &&
										selected.length > 0 &&
										selected?.map((value) => {
											const selectedItemObj = selectOption.find(
												(itemObj) => itemObj.value === value
											);
											return selectedItemObj && (
												<>
													<ChipChild
														key={value}
														label={selectedItemObj?.displayField}
														deleteIcon={
															<ClearIcon
																onMouseDown={(e) => e.stopPropagation()}
															/>
														}
														onDelete={(e) =>
															handleItemDelete(e, selectedItemObj?.value)
														}
													/>
												</>
											);
										})}
								</ChipDiv>
							);
						}}
					>
						{selectOption.map((itemObj) => (
							<StyledMenuItem key={itemObj?.value} value={itemObj?.value}>
								<ListItemText primary={itemObj?.displayField} />
								<StyledCheckBoxItem
									color="secondary"
									checked={multiVal?.indexOf(itemObj?.value) > -1}
								/>
							</StyledMenuItem>
						))}
					</Select>
					{/* {shouldShowClrIcon && (
					<PositionCloseIconMulti
						fontSize="small"
						onClick={onClearMultiple}
						onMouseEnter={handleMouseEnter}
					/>
				)} */}
					<FormHelperText>
						{isBoolean(validationResult) && !validationResult
							? validationMessage
							: info}
					</FormHelperText>
				</FormContainer>
			</div>
		</div>

	}
	return (
		<div className="relative flex items-start gap-1 update-input">
			
			<div className="w-full">
				<div className="flex items-center gap-1 mb-[5px]">
				<span className="min-w-[17px] h-[17px] rounded-7 flex items-center justify-center">
				<CachedImage
					image={ImagePath.dropdownIcon}
					imgKey="drop-picker-Icon"
					className="w-[17px] h-[17px]"
				/>
			</span>
				
					{(isSmallScreen || isSections === true) &&
						<label className="text-size-14 text-[#15194B] font-regular mt-[2px]">
							<Mandatory {...props} />{title}
						</label>
					}
					</div>
				
		<FormContainer
			fullWidth
			variant="outlined"
			size="small"
			disabled={readOnly}
			error={
				validation && isBoolean(validationResult) ? !validationResult : false
			}
			isValue={Boolean(value)}
		>
			{/* {(isSmallScreen || isSections === true) && (
				<InputLabel id={id}>
					<Mandatory {...props} />
					{title}
				</InputLabel>
			)} */}
			<Select
				labelId={id}
				MenuProps={{
					anchorOrigin: {
						vertical: "bottom",
						horizontal: "center",
					},
					style: {
						maxHeight: 45 * 4.5,
					},
				}}
				id={id}
				name={id}
				// label={id}
				value={val || ""}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				onChange={handleSelect}
				variant="outlined"
			>
				{selectOption?.map((itemObj) => (
					<MenuItem key={itemObj?.value} value={itemObj?.value}>
						{itemObj?.displayField}
					</MenuItem>
				))}
			</Select>
			{shouldShowClrIcon && (
				<PositionCloseIcon
					fontSize="small"
					onClick={onClear}
					onMouseEnter={handleMouseEnter}
				/>
			)}
			<FormHelperText>
				{isBoolean(validationResult) && !validationResult
					? validationMessage
					: info}
			</FormHelperText>
		</FormContainer>
		</div>
		</div>
	);
};

export default ObjectInput2;
